//=====================================================
//　全体レイアウト
//=====================================================
import { BrowserRouter, Route } from "react-router-dom";
import { Header } from './header/Header';
import { Footer } from './footer/Footer';
import { Main } from './main/Main';
import { CtxAuth, CtxClinicInfo, CtxClinicSystemInfo, CtxNewReservation, CtxPatientDetailInfo, CtxPatientInfo, CtxSystemErr } from '../utils/Contexts';
import { ThemeColor } from './ThemeColor';
import { useClinicInfo } from "../utils/UseClinicInfo"
import { ClinicInfo } from "./clinicInfo/ClinicInfo";
import { PatientInfo } from "./patientInfo/PatientInfo";
import { useAuth } from "../utils/UseAuth";
import { usePatientInfo } from "../utils/UsePatientInfo";
import { useNewReservation } from "../utils/UseNewReservation";
import { useClinicSystemInfo } from "../utils/UseClinicSystemInfo";
import { usePatientDetailInfo } from "../utils/UsePatientDetailInfo";
import { useEffect } from "react";
import { useState } from "react";
import { G999 } from "../pages/G999/G999";
import { useSystemErr } from "../utils/UseSystemErr";

export function Layout(){

    //医院ID
    const path = window.location.pathname.slice(1); //パスパラメータを先頭の/を除いて取得
    const params = path.split("/");
    let clinicId = params[0];
    
    //各種データ取得
    const userr = useSystemErr();                       //システムエラー情報
    const uci = useClinicInfo(clinicId, userr);         //医院情報
    const ucsi = useClinicSystemInfo(clinicId, userr);  //医院システム情報
    const ua = useAuth();                               //ログイン情報
    const up = usePatientInfo(ua);                      //患者情報
    const unr = useNewReservation();                    //新規予約情報
    const upd = usePatientDetailInfo();                 //患者詳細情報

    //ローディング状況
    const [loadingDone, setLoadingDone] = useState(false);
    const [loadingErr, setLoadingErr] = useState(false);

    //ローディング状態監視処理
    useEffect(function(){
        //医院情報・医院システム情報　取得失敗
        if ((userr.errmess && !uci.data.id) ||
            (userr.errmess && !ucsi.data.usability.system)){
            setLoadingErr(true);
        }
        //取得成功
        if (uci.data.id && ucsi.data.usability.system){
            setTimeout(function(){setLoadingDone(true)}, 2000);
        }
    }, [uci.data, ucsi.data, userr.errmess]);

    //URLに医院IDがない場合、または医院情報が取得できない場合はシステムエラー画面
    if (!clinicId || loadingErr){
        return (
            <BrowserRouter>
                <CtxSystemErr.Provider value={userr}>
                    <div className="style-blue">
                        <Header />
                        <div className='main'>
                            <G999/>
                        </div>
                        <Footer />
                    </div>
                </CtxSystemErr.Provider>
            </BrowserRouter>
        )
    }
    
    //画面描画
    if(!loadingDone) {
        //初期ローディング中画面
        return (
            <div className="loading_init-before">
                <svg version="1.1" className="loading_init-image" id="loading-image" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px"
                    y="0px" viewBox="0 0 441.2 527.9" xmlSpace="preserve">
                    <path className="loading_init-image-line" d="M220.6,45.1c-12.1-4.6-43.9-21-78-20c-37,1-76.6,16.4-97.9,57.6c-17.7,34.3-31.4,88.2-5,173.7
                        c18.2,59,30.1,70.9,41.8,109.4c3.8,12.5,7.6,24.3,10.4,41.5c1.9,11.7,3.7,35.7,5.4,44.9c5.2,28.1,18.4,39.8,27.3,44.9
                        c20.1,11.5,38.2,4.3,51.4-10.7c0,0,15.1-14.6,16.1-50.6c0.9-35.6,7-60.3,28.6-61.8l0-0.1c21.5,1.6,27.5,26.2,28.5,61.8
                        c0.9,35.9,16.1,50.6,16.1,50.6c13.2,15,31.4,22.2,51.4,10.7c8.9-5.1,22.1-16.8,27.3-44.9c1.7-9.2,3.5-33.2,5.4-44.9
                        c2.8-17.1,6.6-29,10.4-41.5c11.7-38.5,23.6-50.4,41.8-109.4c26.4-85.5,12.6-139.4-5-173.7c-21.2-41.2-60.9-56.6-97.9-57.6
                        C264.4,24.1,232.6,40.6,220.6,45.1"/>
                </svg>
            </div>
        )
    } else {
        //初期ローディング完了
        return (
            <div className="loading_init-after">
                <BrowserRouter basename={"/" + clinicId}>
                    <CtxClinicInfo.Provider value={uci}>
                        <CtxClinicSystemInfo.Provider value={ucsi}>
                            <CtxAuth.Provider value={ua}>
                                <CtxPatientInfo.Provider value={up}>
                                    <CtxNewReservation.Provider value={unr}>
                                        <CtxPatientDetailInfo.Provider value={upd}>
                                            <CtxSystemErr.Provider value={userr}>
                                                <ThemeColor>
                                                    <Header />
                                                    <PatientInfo />
                                                    <Main />
                                                    <Route exact path="/">
                                                        <ClinicInfo/>
                                                    </Route>
                                                    <Footer />
                                                </ThemeColor>
                                            </CtxSystemErr.Provider>
                                        </CtxPatientDetailInfo.Provider>
                                    </CtxNewReservation.Provider>
                                </CtxPatientInfo.Provider>
                            </CtxAuth.Provider>
                        </CtxClinicSystemInfo.Provider>
                    </CtxClinicInfo.Provider>
                </BrowserRouter>
            </div>
        );
    }

}